"use client"

import type { HTMLAttributes } from "react"

import { cn } from "../lib/cn"
import { gapClasses, type Gap } from "./layout"

type GridProps = HTMLAttributes<HTMLDivElement> & {
  cols?: number
  gap?: Gap
  min?: number
}

export function Grid({ cols = 2, gap = "md", min, className, style, ...props }: GridProps) {
  return <div className={cn("grid", gapClasses[gap], className)} style={{ ...style, gridTemplateColumns: min ? `repeat(auto-fit, minmax(${min}px, 1fr))` : `repeat(${cols}, minmax(0, 1fr))` }} {...props} />
}
